export default __webpack_public_path__ + "static/media/Vedana.a6fbc326.png";